import React from "react";
import "./HomeCtaBanner.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

export default function HomeCtaBanner({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";
  const navigate = useNavigate();

  // ================= ENGLISH DATA =================
  const dataEN = {
    heading: "Is Your Business Ready for What’s Next?",
    text:
      "Let our specialists help you navigate financial challenges, unlock value, and achieve measurable growth across every function.",
    button: "Let’s Talk",
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    heading: "Votre entreprise est-elle prête pour la suite ?",
    text:
      "Nos spécialistes vous accompagnent pour relever vos défis financiers, créer de la valeur et générer une croissance mesurable à tous les niveaux.",
    button: "Parlons-en",
  };

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;
  const { heading, text, button } = data;

  return (
    <section className="home-cta-section">
      <div className="cta-box d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between">
        {/* Left Side Content */}
        <div className="cta-left">
          <h2 className="cta-heading">{heading}</h2>
          <p className="cta-text">{text}</p>
        </div>

        {/* Right Side Button */}
        <div className="mt-lg-0">
          <button
            className="cta-btn"
            onClick={() => navigate("/contact")}
          >
            {button}
            <img
              src="/assets/icons/BlueRightArrow.png"
              alt="arrow"
              className="right-arrow-icon"
            />
          </button>
        </div>
      </div>
    </section>
  );
}
